// extracted by mini-css-extract-plugin
export var modal = "_u8-0";
export var table = "_u8-1";